import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { SalaryTimesheet } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
// import { convertUTCtoISTWithMinus } from "@/utils";
// import { DataTableRowActions } from "./data-table-row-actions";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<SalaryTimesheet>[] {
  return [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <span>{row.index + 1}.</span>
              <span className="font-medium text-[17px]">
                {row.original?.employeeName}
              </span>
            </div>
            {row.original.createdAt && (
              <div>
                ( Created at -{" "}
                {format(new Date(row.original.createdAt), "PPpp")} )
              </div>
            )}
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "month",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Month" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("month")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "year",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Year" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("year")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      id: "markings",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Attendance" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-y-2 flex-col">
            <div className="flex items-center gap-3">
              <p>Present - {row.original?.present}</p>
            </div>
            <div className="flex items-center gap-3">
              <p>Absent - {row.original?.absent}</p>
            </div>
            <div className="flex items-center gap-3">
              <p>Paid Leave - {row.original?.paidLeave}</p>
            </div>
            <div className="flex items-center gap-3">
              <p>Unpaid Leave - {row.original?.unpaidLeave}</p>
            </div>
          </div>
        );
      },
      enableSorting: false,
    },
    // {
    //   accessorKey: "totalDeductions",
    //   header: ({ column }) => (
    //     <DataTableColumnHeader column={column} title="Total Deductions" />
    //   ),
    //   cell: ({ row }) => {
    //     return (
    //       <div className="flex space-x-2">
    //         <span className="max-w-[500px] truncate font-medium">
    //           {row.getValue("totalDeductions")}
    //         </span>
    //       </div>
    //     );
    //   },
    //   enableSorting: false,
    // },
    // {
    //   accessorKey: "netPay",
    //   header: ({ column }) => (
    //     <DataTableColumnHeader column={column} title="Net Pay" />
    //   ),
    //   cell: ({ row }) => {
    //     return (
    //       <div className="flex space-x-2">
    //         <span className="max-w-[500px] truncate font-medium">
    //           {row.getValue("netPay")}
    //         </span>
    //       </div>
    //     );
    //   },
    //   enableSorting: false,
    // },
    // {
    //   accessorKey: "approved",
    //   header: ({ column }) => (
    //     <DataTableColumnHeader column={column} title="Status" />
    //   ),
    //   cell: ({ row }) => {
    //     return (
    //       <div className="flex space-x-2">
    //         <Badge>
    //           {row.getValue("approved") === true ? "Approved" : "Not Approved"}
    //         </Badge>
    //       </div>
    //     );
    //   },
    //   enableSorting: false,
    // },

    // {
    //   id: "actions",
    //   cell: ({ row }) => <DataTableRowActions row={row} />,
    // },
  ];
}
